import { RequestHandler, http, HttpResponse } from 'msw'

import { getApiRoute } from '@core/utils/api'

import { groupByClubLegacyMock } from '@services/Legacy/mocks'
import { getLegacyPeopleGroupByClubConfig } from '@services/Legacy/api'

type UrlParams = { params: { clubHash: string } }

export const getLegacyPeopleGroupByClubHandler: RequestHandler = http.get(
  getApiRoute<UrlParams>(getLegacyPeopleGroupByClubConfig.url, { params: { clubHash: groupByClubLegacyMock.club.id } }, 'legacy'),
  () => HttpResponse.json([groupByClubLegacyMock]),
)

export default [
  getLegacyPeopleGroupByClubHandler,
]
